import { ColumnDef, Row, RowData } from '@tanstack/table-core';
import React from 'react';

import Chevron from '@/assets/Icon/svg/Chevron';
import { styToggleExpander } from './style';

function ToggleExpander<TData extends RowData>({ row }: { row: Row<TData> }) {
  const expandRow = row.getToggleExpandedHandler();

  const handleKeyDown = (e) => {
    if (e.key === 'enter') {
      expandRow();
    }
  };

  return (
    <button
      type="button"
      onClick={expandRow}
      onKeyDown={handleKeyDown}
      className={styToggleExpander}
    >
      {row.getIsExpanded() ? <Chevron.Up /> : <Chevron.Down />}
    </button>
  );
}

function getExpandColumnDef<TData extends RowData>(): ColumnDef<TData, unknown> {
  return {
    id: 'expander',
    header: () => null,
    cell({ row }) {
      return row.getCanExpand() && <ToggleExpander<TData> row={row} />;
    },
    size: 1,
  };
}

export default getExpandColumnDef;
